var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e3e3e3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220-100v-720h600l-81.92 185.39L820-449.23H280V-100h-60Zm60-409.23h449.31l-56.46-125.38L729.31-760H280v250.77Zm0 0V-760-509.23Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIc);
export default __webpack_public_path__ + "static/media/flag_ic.63b10b7828d6120e7a6abe49f9e1dcd9.svg";
export { ForwardRef as ReactComponent };